import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { Institution, Facility, EduFamilySurvey, Unit } from 'projects/shared-lib/src/public-api';


@Component({
    selector: 'seach-results-modal',
    templateUrl: './seach-results-modal.component.html',
    styleUrls: ['./seach-results-modal.component.css']
})
export class SearchResultsModalComponent implements OnInit {

    public householdIdControl: FormControl;
    public groupedSurveys: any[];

    constructor(public dialogRef: MatDialogRef<SearchResultsModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            surveys: EduFamilySurvey[];
            districts: Institution[];
    }){
    }

    ngOnInit(){
        this.householdIdControl = new FormControl("", [Validators.required]);
        this.groupSurveys();
    }

    public getListOfSchools(distId: number): any[] {
        if (!distId) return [];
        let selectedDistrict = this.data.districts.find((d) => d.id == distId);
        if (selectedDistrict) return selectedDistrict.facilities;
        else [];
    }

    public getSchoolName(id){
        let schoolFound: Facility = null;
        this.data.districts.forEach(d => {
            var found = d.facilities.find(f => f.id == id);
            if(found){
                schoolFound = found;
            }
        });
        return (schoolFound)?schoolFound.name:"";
    }

    public getDistrictName(id){
        let districtFound = this.data.districts.find(d => d.id == id);
        return (districtFound)? districtFound.description : "";
    }

    public getGradeName(id){
        let gradeFound: Unit = null;
        
        this.data.districts.forEach(d => {
            var found = d.facilities.forEach(f => {
                var found = f.units.find(u => u.id == id);
                if(found){
                    gradeFound = found;
                }
            });
        });

        return (gradeFound) ? gradeFound.description : "";

    }

     public onConfirm(){
        this.dialogRef.close(this.householdIdControl.value);
    }
    
    public onCancel(){
        this.dialogRef.close(null);
    }

    public onSaveNew(){
        this.dialogRef.close(false);
    }

    private groupSurveys(){
        var groups = [];
        this.data.surveys.forEach(function (s) {
            groups[s.houseHoldId] = groups[s.houseHoldId] || [];
            groups[s.houseHoldId].push(s);
        }.bind(this));
        this.groupedSurveys = groups;
    }
    
}